import React from 'react';

import { Flex } from 'antd-v5';
import { useSelector } from 'react-redux';

import { useRosterLite } from '@modules/roster-lite/duck/hooks';
import PageContainer from '@shared/components/Layouts/PageContainer';
import { organizationGuidSel } from '@shared/duck/selectors/general.selectors';

import styles from './RosterLitePage.module.scss';
import RosterLiteTable from './RosterLiteTable';
import UnitInformationCard from './UnitInformationCard';

const RosterLitePage: React.FC = () => {
  const organizationGuid = useSelector(organizationGuidSel);
  const { members, loadingYouths, loadingAdults } = useRosterLite({});

  return (
    <PageContainer>
      <Flex vertical gap="middle">
        <UnitInformationCard organizationGuid={organizationGuid} />
        <div className={styles.tableContainer}>
          <RosterLiteTable
            members={members}
            loading={loadingYouths || loadingAdults}
          />
        </div>
      </Flex>
    </PageContainer>
  );
};

export default RosterLitePage;
